import { useState } from 'react'
import { AppBar, Box, Button, Drawer, IconButton, List, ListItemButton, ListItemText, Toolbar, Typography } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { HashLink } from 'react-router-hash-link'
import useStyles, { colors } from '../styles/styles'

const navItems = ['About', 'Projects', 'Contact']

const Navbar = () => {
  const classes = useStyles()
  const [mobileOpen, setMobileOpen] = useState(false)
  const closeMenu = () => setMobileOpen(false)

  const link = (item) => `/#${item.toLowerCase()}`

  return (
    <>
      <AppBar component="nav" position="fixed" className={classes.nav}>
        <Toolbar className={classes.toolbar}>
          <Button component={HashLink} smooth to="/#home" className={classes.navStyling} sx={{ color: `${colors.accent} !important`, fontFamily: 'monospace', textTransform: 'none', fontWeight: 700 }}>Mahadi.</Button>
          <Box className={classes.navLinks} sx={{ display: { xs: 'none', sm: 'flex' } }}>
            {navItems.map((item, index) => (
              <Button key={item} component={HashLink} smooth to={link(item)} className={classes.navStyling} sx={{ textTransform: 'none' }}>
                <Typography component="span" sx={{ color: colors.accent, fontFamily: 'monospace', fontSize: '0.68rem', mr: 0.7 }}>0{index + 1}</Typography>{item}
              </Button>
            ))}
          </Box>
          <IconButton color="inherit" aria-label="open navigation" onClick={() => setMobileOpen(true)} sx={{ display: { sm: 'none' }, color: colors.muted }}><MenuIcon /></IconButton>
        </Toolbar>
      </AppBar>
      <Drawer anchor="right" open={mobileOpen} onClose={closeMenu} PaperProps={{ sx: { width: 260, background: colors.surface, borderLeft: `1px solid ${colors.border}` } }}>
        <List sx={{ pt: 10 }}>
          {navItems.map((item, index) => (
            <ListItemButton key={item} component={HashLink} smooth to={link(item)} onClick={closeMenu} className={classes.navStyling} sx={{ px: 4, py: 2 }}>
              <Typography component="span" sx={{ color: colors.accent, fontFamily: 'monospace', fontSize: '0.72rem', mr: 1.5 }}>0{index + 1}</Typography>
              <ListItemText primary={item} />
            </ListItemButton>
          ))}
        </List>
      </Drawer>
    </>
  )
}

export default Navbar
